import { forwardRef } from 'react';
import { TextField } from '@mui/material';

import BaseFieldContainer from '../common/baseFieldContainer';
import { mergeSx, mergeSxWithOutlinedBorder } from '../utils/general';
import { getMultilineSizingProps } from './utils/general';
import { FORTA_BLACK } from '../../../utils/colors';

import type { FTextAreaProps } from './types';

const FTextArea = forwardRef<HTMLDivElement, FTextAreaProps>(function FTextArea(props, ref) {
  const {
    variant = 'outlined',
    multiline = true,
    rows: rowsProp,
    minRows,
    maxRows,
    sx,
    required,
    disabled,
    InputLabelProps,
    helperText,
    fullWidth,
    ...rest
  } = props;

  const multilineSizingProps = getMultilineSizingProps(rowsProp, minRows, maxRows);
  const inputLabelProps = {
    ...InputLabelProps,
    required: required && !disabled ? false : undefined,
    shrink: true,
    sx: mergeSx({ color: FORTA_BLACK }, InputLabelProps?.sx),
  };

  return (
    <BaseFieldContainer
      required={required}
      disabled={disabled}
      helperText={helperText}
      error={rest.error ?? false}
      fullWidth={fullWidth}
    >
      <TextField
        ref={ref}
        variant={variant}
        multiline={multiline}
        required={required}
        disabled={disabled}
        InputLabelProps={inputLabelProps}
        helperText={helperText}
        fullWidth={fullWidth}
        sx={mergeSxWithOutlinedBorder(sx)}
        {...multilineSizingProps}
        {...rest}
      />
    </BaseFieldContainer>
  );
});

export default FTextArea;
